import useWindow from '../../ISO/Hooks/useWindow';

function UseQuery(): {
  param: (name: string) => string | null;
  buildParam: (param: string, value: string) => string;
  section: {
    get: () => string | null;
    build: (value: string) => string;
  };
} {
  const window = useWindow();
  const SectionQueryParamName = 'section';
  const query = new URLSearchParams(window?.location?.search);

  const param = (name: string): string | null => {
    return query.get(name);
  };

  const buildParam = (name: string, value: string): string => {
    return `?${name}=${value}`;
  };

  return {
    param,
    buildParam,
    section: {
      get: (): string | null => {
        return param(SectionQueryParamName);
      },
      build: (value: string): string => {
        return buildParam(SectionQueryParamName, value);
      }
    }
  };
}

export default UseQuery;
